var _path, _path2, _path3, _path4, _line;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoVmIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 45,
    viewBox: "0 0 56 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3574 31.0714V26.7857C15.3574 25.6491 15.809 24.559 16.6127 23.7553C17.4164 22.9515 18.5065 22.5 19.6431 22.5H45.3574C46.4941 22.5 47.5842 22.9515 48.3879 23.7553C49.1916 24.559 49.6431 25.6491 49.6431 26.7857V31.0714C49.6431 32.2081 49.1916 33.2982 48.3879 34.1019C47.5842 34.9056 46.4941 35.3571 45.3574 35.3571H19.6431C18.5065 35.3571 17.4164 34.9056 16.6127 34.1019C15.809 33.2982 15.3574 32.2081 15.3574 31.0714Z",
    stroke: "#16151C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.9283 28.9319C23.9283 28.3636 23.7025 27.8186 23.3007 27.4167C22.8988 27.0148 22.3538 26.7891 21.7854 26.7891C21.2171 26.7891 20.6721 27.0148 20.2702 27.4167C19.8683 27.8186 19.6426 28.3636 19.6426 28.9319C19.6426 29.5002 19.8683 30.0453 20.2702 30.4471C20.6721 30.849 21.2171 31.0748 21.7854 31.0748C22.3538 31.0748 22.8988 30.849 23.3007 30.4471C23.7025 30.0453 23.9283 29.5002 23.9283 28.9319Z",
    fill: "#16151C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3574 18.2031L15.3789 13.9174C15.3823 12.783 15.8353 11.6962 16.6386 10.8952C17.442 10.0943 18.5301 9.64453 19.6646 9.64453H45.3574C46.4383 9.64473 47.4792 10.0533 48.2715 10.7885C49.0639 11.5236 49.5492 12.531 49.6303 13.6088L49.6431 13.9431L49.6217 18.2288C49.6183 19.3632 49.1653 20.45 48.3619 21.251C47.5586 22.0519 46.4704 22.5017 45.336 22.5017H19.6431C18.5619 22.502 17.5205 22.0937 16.7277 21.3585C15.9349 20.6233 15.4492 19.6156 15.3681 18.5374L15.3574 18.2031Z",
    stroke: "#16151C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.9283 16.0725C23.9283 15.5042 23.7025 14.9592 23.3007 14.5573C22.8988 14.1555 22.3538 13.9297 21.7854 13.9297C21.2171 13.9297 20.6721 14.1555 20.2702 14.5573C19.8683 14.9592 19.6426 15.5042 19.6426 16.0725C19.6426 16.6409 19.8683 17.1859 20.2702 17.5878C20.6721 17.9896 21.2171 18.2154 21.7854 18.2154C22.3538 18.2154 22.8988 17.9896 23.3007 17.5878C23.7025 17.1859 23.9283 16.6409 23.9283 16.0725Z",
    fill: "#16151C"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 0.284216,
    y1: 1.58863,
    x2: 55.2842,
    y2: 39.5886,
    stroke: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoVmIcon);
export default __webpack_public_path__ + "static/media/no-vm-icon.c0741109f23e67c72310541a0b4abd86.svg";
export { ForwardRef as ReactComponent };